<template>
  <div>
    <label 
      v-if="props.label" 
      :for="props.id" 
      class="block mb-2 text-sm font-medium text-custom_gray"
    >
      {{ props.label }}
    </label>
    <div class="relative">
      <input 
        :id="props.id"
        :type="showPassword ? 'text' : 'password'" 
        :value="props.modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="$emit('blur', $event)"
        :name="props.name"
        :placeholder="props.placeholder"
        :class="props.error ? 'border border-red-500 bg-red-50 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5' : 'bg-white border border-gray-300 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5'"
      />
      <button 
        type="button" 
        @click="togglePasswordVisibility" 
        class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 focus:outline-none"
      >
        <!-- Icono de ojo abierto cuando la contraseña está oculta -->
        <svg 
          v-if="!showPassword" 
          xmlns="http://www.w3.org/2000/svg" 
          class="h-5 w-5" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="2" 
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" 
          />
          <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="2" 
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" 
          />
        </svg>
        <!-- Icono de ojo cerrado cuando la contraseña está visible -->
        <svg 
          v-else 
          xmlns="http://www.w3.org/2000/svg" 
          class="h-5 w-5" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="2" 
            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" 
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: 'Contraseña'
  },
  placeholder: {
    type: String,
    default: 'Ingresa tu contraseña'
  },
  inputClass: {
    type: String,
    default: 'border border-gray-300'
  },
  name: {
    type: String,
    default: 'password'
  },
  id: {
    type: String,
    default: 'password'
  },
  error: {
    type: String,
    default: ''
  },
  errorClass: {
    type: String,
    default: ''
  }
});

defineEmits(['update:modelValue', 'blur']);

const showPassword = ref(false);

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value;
};
</script>

<style scoped>
/* Puedes agregar estilos adicionales aquí si es necesario */
</style>
